// extracted by mini-css-extract-plugin
export default {"backgroundChartCategory":"ChartCategory_backgroundChartCategory__L4T2r"};